export default {
  slug: 'ws-media',
};
